// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import { getClient } from 'configcat-js';

const CONFIGCAT_DEV_SDK_KEY = 'configcat-sdk-1/U1LZCJjCt0SJTlnADO4xEA/kn1yJun9sUWXsmvxJ6cyVw';
export const CONFIGCAT_KEY = process.env.REACT_APP_CONFIGCAT_KEY || CONFIGCAT_DEV_SDK_KEY;

export const configCatClient = getClient(CONFIGCAT_KEY);

export const FEATURE_FLAG = {
  SELF_SERVE_RESTRICTED_EMAIL_DOMAINS: 'selfServeRestrictedEmailDomains',
  HIDE_REQUEST_ACCESS: 'hideRequestAccess',
  SPECIFIC_DESCRIPTIONS: 'tsSpecificDescriptions',
  POLICY_DATA_ROOM_ACCESS: 'policyDownloadsRestricted',
  AUTO_ALIGN_TRUST_LEADERS: 'autoAlignTrustLeaders',
  EXTRA_SELF_SERVE_RESTRICTED_EMAIL_DOMAINS: 'extraSelfServeRestrictedEmailDomains',
  DISABLE_CONTINUOUSLY_MONITORED: 'disableContinuouslyMonitored',
  HIDE_DATA_ROOM_REQUEST_ACCESS: 'hideDataRoomRequestAccess',
  VIEW_ONLY_DOCUMENTS: 'enableViewOnlyDocuments',
  DISABLE_MULTIPLE_CERTIFICATIONS: 'disableMultipleCertifications',
  SEGMENT_AWARE_TS_PORTAL_V1: 'segmentAwareTrustSharePortalV1',
  ENTERPRISE_GRADE_TS: 'enterpriseGradeTrustshare',
};
